<template>
    <div class="page">
        <div class = "monitor-header">
            <div class = "time-header">
                <el-button icon="jc-icon-refresh-line" class="jc-button-icon"
                @click="handleRefresh"></el-button>
                <div>
                    <el-radio-group ref="radios"
                        v-model="pickerShortcutButton"
                        @change="onDateRangeChange">
                        <el-radio-button v-for="item in shortcuts"
                            :key="item.label"
                            :label="item.label">{{item.name}}
                        </el-radio-button>
                    </el-radio-group>
                    <el-date-picker ref="picker"
                        v-model="pickerValue"
                        :placeholder="$t('detail.text.rangeForSearch')"
                        :range-separator="$t('detail.text.rangeSeparator')"
                        :editable="false"
                        :picker-options="pickerOptions"
                        @change="pickerChange"
                        type="daterange"
                        format="yyyy-MM-dd"
                        align="right"
                        unlink-panels>
                    </el-date-picker>
                </div>
                <div class="monitor-alarm-rule">
                    <!-- @TODO 原来没有cps这层path 'monitor/resource/auto/' -->
                    <p>{{$t('listPage.speechCraft.monitorTo') }}<a :href="Config.MONITOR_RULE_URL+'monitor/resource/auto/cps/'+cpsType+'/'+resourceId+'?regionId='+ regionId+'&resourceId='+resourceId+'&viewType=rule'" target="_blank">
                    {{$t('listPage.speechCraft.alarmRules') }}</a></p>
                </div>
            </div>
            <div class="select-instance">
                <el-radio-group v-model="selectInstance">
                    <el-radio :label="1">{{$t('detail.text.monitorInstance')}}</el-radio>
                    <el-radio :label="2">{{$t('detail.text.monitorDisk')}}</el-radio>
                    <el-tooltip effect="dark" placement="top">
                        <div slot="content" class="my-os-disk-tip">
                        {{$t('detail.speechCraft.dickTip')}}
                        </div>
                        <a><i class="jc-icon-question"></i></a>
                    </el-tooltip>
                    <div class="select-disk" v-if="selectInstance===2 && diskGroup[0]">
                        <el-select v-model="diskChange"
                        @change="diskChooseChange">
                            <el-option
                            v-for="item in diskGroup"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <el-radio :label="3">{{$t('detail.text.monitorDiskPiece')}}</el-radio>
                    <el-tooltip effect="dark" placement="top">
                        <div slot="content" class="my-os-disk-tip">
                        {{$t('detail.speechCraft.dickPieceTip')}}
                        </div>
                        <a><i class="jc-icon-question"></i></a>
                    </el-tooltip>
                    <div class="select-disk" v-if="selectInstance===3 && mountpointGroup[0]">
                        <el-select v-model="mountpointChange"
                        @change="mountpointChooseChange">
                            <el-option
                            v-for="item in mountpointGroup"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <el-radio :label="4">{{$t('detail.text.net')}}</el-radio>
                    <div class="select-disk" v-if="selectInstance===4 && nicGroup[0]">
                        <el-select v-model="nicChange"
                        @change="nicChooseChange">
                            <el-option
                            v-for="item in nicGroup"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <!-- GPU监控 -->
                    <el-radio v-if="canShowGPUMonitor" :label="5">GPU</el-radio>
                </el-radio-group>
            </div>

        </div>
        <div class="monitor-chart">
            <div v-for="(item,index) in metrics">
                <single-monitor-chart
                    :key='item.guid'
                    :metric="item.include"
                    :serviceCode="serviceCode"
                    :groupCode="cpsType"
                    :title='item.title'
                    :initialTitle="item.initialTitle"
                    :resourceId="resourceId"
                    :regionId="regionId"
                    :timeInterval="pickerShortcutButton"
                    :startTime="startTime"
                    :endTime="endTime"
                    :selectChange="selectInstance"
                    :changeDisk="diskChangeList"
                    :changeMountpoint="mountpointChangeList"
                    :changeNic="nicChangeList"
                    :updateSign="updateChange"
                    :nicChange="nicChange"
                    :mountpointChange="mountpointChange"
                />
            </div>
            <div class="add-border">{{'none'}}</div>
        </div>
    </div>
</template>

<script>
import {ServiceCodeConstant} from "@/common/Constants";
import {guid} from "@/common/tool";
import SingleMonitorChart from "@/components/common/PerformanceMonitor/SingleMonitorChart.vue";

const ONE_HOUR = 3600 * 1000;
const _now = () => (new Date()).getTime();
export default {
    name: 'PerformanceMonitor',
    components: { SingleMonitorChart },
    data() {
        return {
            pickerValue:'',
            keyValue:1,
            pickerShortcutButton: '1h',
            selectInstance: 1,
            cpsType:'',
            dateRangeValue: '',
            diskChange: '',
            mountpointChange:'',
            nicChange:'',
            disk:'',
            diskChangeList:{},
            mountpointChangeList:{},
            nicChangeList:{},
            diskGroup:[],
            mountpointGroup:[],
            nicGroup:[],
            resourceId:'',
            regionId:'',
            updateChange: 0,
            startTime:'',
            endTime:'',
            shortcuts: [
                { label: '1h', name: '1'+ this.$t('detail.text.timeRangeH') },
                { label: '6h', name: '6'+ this.$t('detail.text.timeRangeH') },
                { label: '12h', name: '12'+ this.$t('detail.text.timeRangeH') },
                { label: '1d', name: '1'+ this.$t('detail.text.timeRangeD') },
                { label: '3d', name: '3'+ this.$t('detail.text.timeRangeD') },
                { label: '7d', name: '7'+ this.$t('detail.text.timeRangeD') },
                { label: '14d', name: '14'+ this.$t('detail.text.timeRangeD') },
            ],

            metrics: [
                {include:['cps.cpu.util'], guid:guid()},
                {include:['cps.memory.util'], guid:guid()},
                {include:['cps.memory.used'], guid:guid()},
                {include:['cps.disk.used'], guid:guid()},
                {include:['cps.disk.util'], guid:guid()},
                {include:['cps.disk.bytes.read',
                        'cps.disk.bytes.write'
                ], guid:guid(), title: this.$t('detail.text.diskReadWrite')},
                {include: [
                    'cps.disk.counts.read',
                    'cps.disk.counts.write'
                ], guid:guid(), title: this.$t('detail.text.diskCountReadWrite')},
                {include:[
                    'cps.network.bytes.ingress',
                    'cps.network.bytes.egress'
                ], guid:guid(), title: this.$t('detail.text.networkTraffic')},
                {include:[
                    'cps.network.packets.ingress',
                    'cps.network.packets.egress'
                ], guid:guid(), title: this.$t('detail.text.networkPacket')},
                {include:['cps.avg.load1'], guid:guid()},
                {include:['cps.avg.load5'], guid:guid()},
                {include:['cps.avg.load15'], guid:guid()},
                {include:['cps.tcp.connect.total'], guid:guid()},
                {include:['cps.tcp.connect.established'], guid:guid()},
                {include:['cps.process.total'], guid:guid()},

            ],
            serviceCode: ServiceCodeConstant.CPS,
            resourceId: this.$route.query.id,
            regionId: this.$route.query.region,

            pickerOptions: {
                disabledDate (time) {
                    const t = time.getTime();
                    const now = _now();
                    const laterThenNow = t > now;
                    const earlierThenRange = t < now - ONE_HOUR * 24 * 30;
                    return earlierThenRange || laterThenNow;
                },
                onPick ({ maxDate, minDate }) {
                    const bothSelected = !!maxDate && !!minDate;
                    if (!bothSelected) return; // 解决首次不触发
                    setTimeout(() => {
                        this.pickerValue = [minDate, maxDate];
                        //console.log('position 1', this.pickerValue);
                    }, 200);
                }
            },
            canShowGPUMonitorPath: ['/instance/vpc/detail/performance'], // 能展示GPU监控的路由，目前只有“私有网络实例”展示，该组件还被“基础网络实例”/instance/basic/detail/performance、“零售中台实例”/instance/retail/detail/performance详情页使用

        };
    },
    computed: {
        ServiceCodeConstant: () => ServiceCodeConstant,
        /**
         * @description 判断性能监控是否展示GPU监控，目前只有“私有网络实例”展示，该组件还被“基础网络实例”、“零售中台实例”详情页使用
         */
        canShowGPUMonitor () {
            const path = this.$route.path
            return this.canShowGPUMonitorPath.includes(path)
        }
    },
    watch: {
        selectInstance(val) {
            // 实例
            if(val===1) {
                this.resetMetrics(this.imageType);
                this.diskChangeList = {};
                this.nicChangeList = {};
                this.mountpointChangeList = {};
            }else if(val===2) { // 磁盘
                this.metrics = [
                        {include:['cps.disk.used'], guid:guid(), title: this.$t('detail.text.diskUsed')},
                        {include:['cps.disk.util'], guid:guid(), title: this.$t('detail.text.diskUtil')},
                        {include: [
                        'cps.disk.bytes.read',
                        'cps.disk.bytes.write'
                        ], guid:guid(), title: this.$t('detail.text.diskReadWrite')},
                        {include: [
                        'cps.disk.counts.read',
                        'cps.disk.counts.write'
                        ], guid:guid(), title: this.$t('detail.text.diskCountReadWrite')},
                    ];
                this.nicChangeList = {};
                this.mountpointChangeList = {};
                if(this.diskGroup[0]) {
                    this.diskChangeList = {
                        groupBy: true,
                        tags: [
                            {
                                key:"device",
                                values: [this.diskGroup[0].value]
                            }
                        ]
                    }
                this.diskChange = this.diskGroup[0].value
                }


            }else if(val===3) { // 磁盘分区
                if(this.mountpointGroup[0]) {
                    this.mountpointChange = this.mountpointGroup[0].value
                    this.metrics = [
                        {include:['cps.disk.partition.used'], guid:guid(),initialTitle: this.$t('detail.text.diskUsed'), title: '(' + this.mountpointChange + ')' + this.$t('detail.text.diskUsed') },
                        {include:['cps.disk.partition.util'], guid:guid(),initialTitle: this.$t('detail.text.diskUtil'), title: '(' + this.mountpointChange + ')' + this.$t('detail.text.diskUtil') },
                    ];
                    this.mountpointChangeList = {
                        groupBy: true,
                        tags: [
                            {
                                key:"device",
                                values: [this.mountpointChange]
                            }
                        ]
                    }
                } else {
                    this.metrics = [
                        {include:['cps.disk.partition.used'], guid:guid(),initialTitle: this.$t('detail.text.diskUsed'), title: this.$t('detail.text.diskUsed') },
                        {include:['cps.disk.partition.util'], guid:guid(),initialTitle: this.$t('detail.text.diskUtil'), title: this.$t('detail.text.diskUtil') },
                    ];
                }
                this.diskChangeList = {};
                this.nicChangeList = {};



            }else if(val===4){ // 网口
                if(this.nicGroup[0]) {
                    this.nicChange = this.nicGroup[0].value
                    this.metrics = [
                        {include:[
                            'cps.network.bytes.ingress',
                            'cps.network.bytes.egress'
                        ], guid:guid(), initialTitle: this.$t('detail.text.networkTraffic'), title: '(' + this.nicChange + ')' + this.$t('detail.text.networkTraffic') },
                        {include:[
                            'cps.network.packets.ingress',
                            'cps.network.packets.egress'
                        ], guid:guid(), initialTitle: this.$t('detail.text.networkPacket'),  title: '(' + this.nicChange + ')' + this.$t('detail.text.networkPacket') },

                    ];
                    this.nicChangeList = {
                        groupBy: true,
                        tags: [
                            {
                                key:"device",
                                values: [this.nicChange]
                            }
                        ]
                    }

                } else {
                    this.metrics = [
                        {include:[
                            'cps.network.bytes.ingress',
                            'cps.network.bytes.egress'
                        ], guid:guid(), initialTitle: this.$t('detail.text.networkTraffic'), title: this.$t('detail.text.networkTraffic') },
                        {include:[
                            'cps.network.packets.ingress',
                            'cps.network.packets.egress'
                        ], guid:guid(), initialTitle: this.$t('detail.text.networkPacket'),  title: this.$t('detail.text.networkPacket') },

                    ];
                }
                this.diskChangeList = {};
                this.mountpointChangeList = {};

            // GPU监控
            }else if (val===5) {
                this.metrics = [
                    {include:['cps.gpu.memory.total'], guid:guid(),initialTitle: this.$t('detail.text.gpuMemoryTotal') + "（GB）", title: this.$t('detail.text.gpuMemoryTotal') },
                    {include:['cps.gpu.util'], guid:guid(),initialTitle: this.$t('detail.text.gpuUtilization') + "%", title: this.$t('detail.text.gpuUtilization') },
                    {include:['cps.gpu.memory.used'], guid:guid(),initialTitle: this.$t('detail.text.gpuMemoryUsed') + "（GB）", title: this.$t('detail.text.gpuMemoryUsed') },
                    {include:['cps.gpu.memory.util'], guid:guid(),initialTitle: this.$t('detail.text.gpuMemoryUtilization') + "%", title: this.$t('detail.text.gpuMemoryUtilization') },
                ]
                this.nicChangeList = {};
                this.mountpointChangeList = {};
                this.diskChangeList = {};
            } ;
            if(this.pickerShortcutButton !== '') {
                this.pickerValue = ''
                this.startTime = ''
                this.endTime = ''
           };
       },

    },
    created() {
        this.getDiskGroup();
        this.getMountpointGroup();
        this.getNicsGroup();
        this.cpsType = this.$route.query.cpsType;
        this.resourceId = this.$route.query.id;
        this.regionId = this.$route.query.region;
        this.imageType = this.$route.query.imageType;
        this.resetMetrics(this.imageType);
    },
    methods: {
        handleRefresh() {
            this.updateChange ++;
        },
        onDateRangeChange() {
           if(this.pickerShortcutButton !== '') {
                this.pickerValue = ''
           }
        },
        pickerChange() {
            if(this.pickerValue[1] !== null) {
                this.pickerShortcutButton = ''
                this.startTime = new Date(+this.pickerValue[0] + 8 * 3600 * 1000).toISOString().replace(/\.[\d]{3}Z/,'');
                this.endTime = new Date(+this.pickerValue[1] + 32 * 3600 * 1000 - 1 ).toISOString().replace(/\.[\d]{3}Z/,'');
            }
        },
        getDiskGroup() {
            const params = {
                region: this.regionId,
                instance_id: this.resourceId
            };
		  	Ajax.get('/api/cps/queryInstanceDisks',params).then((res) => {
				if (res.data) {
                    const disklist = res.data.disk;
                    const filtersArray = [];
                    disklist.forEach((element, index) => {
                        const filter = {};
                        filter.label = index;
                        filter.value = element;
                        filtersArray.push(filter);
                    });
                    this.diskGroup = filtersArray
				}
		  	});
		},
        getMountpointGroup() {
            const params = {
                region: this.regionId,
                instance_id: this.resourceId,
            };
		  	Ajax.get('/api/cps/queryInstanceMountpoints',params).then((res) => {
				if (res.data) {
                    const disklist = res.data.mountpoints;
                    const filtersArray = [];
                    disklist.forEach((element, index) => {
                        const filter = {};
                        filter.label = index;
                        filter.value = element;
                        filtersArray.push(filter);
                    });
                    this.mountpointGroup = filtersArray
				}
		  	});
		},
        getNicsGroup() {
            const params = {
                region: this.regionId,
                instance_id: this.resourceId,
            };
		  	Ajax.get('/api/cps/queryInstanceNics',params).then((res) => {
				if (res.data) {
                    const disklist = res.data.nics;
                    const filtersArray = [];
                    disklist.forEach((element, index) => {
                        const filter = {};
                        filter.label = index;
                        filter.value = element;
                        filtersArray.push(filter);
                    });
                    this.nicGroup = filtersArray
				}
		  	});
		},
        diskChooseChange() {
            this.diskChangeList = {
                    groupBy: true,
                    tags: [
                        {
                            key:"device",
                            values: [this.diskChange]
                        }
                    ]
                }
        },
        mountpointChooseChange() {
            this.mountpointChangeList = {
                    groupBy: true,
                    tags: [
                        {
                            key:"device",
                            values: [this.mountpointChange]
                        }
                    ]
                }
        },
        nicChooseChange() {
            this.nicChangeList = {
                groupBy: true,
                tags: [
                    {
                        key:"device",
                        values: [this.nicChange]
                    }
                ]
            }
        },
        resetMetrics(imageType) {
            // GPU监控项
            const gpuMonitors = [
                {include:['cps.gpu.memory.total'], guid:guid(),initialTitle: this.$t('detail.text.gpuMemoryTotal') + "（GB）", title: this.$t('detail.text.gpuMemoryTotal') },
                {include:['cps.gpu.util'], guid:guid(),initialTitle: this.$t('detail.text.gpuUtilization') + "%", title: this.$t('detail.text.gpuUtilization') },
                {include:['cps.gpu.memory.used'], guid:guid(),initialTitle: this.$t('detail.text.gpuMemoryUsed') + "（GB）", title: this.$t('detail.text.gpuMemoryUsed') },
                {include:['cps.gpu.memory.util'], guid:guid(),initialTitle: this.$t('detail.text.gpuMemoryUtilization') + "%", title: this.$t('detail.text.gpuMemoryUtilization') },
            ]
            if (imageType === "Windows") {
                this.metrics = [
                    {include:['cps.cpu.util'], guid:guid(), title: this.$t('detail.text.cpuUsed')},
                    {include:['cps.memory.util'], guid:guid(), title: this.$t('detail.text.memoryUsed')},
                    {include:['cps.memory.used'], guid:guid(), title: this.$t('detail.text.memoryUtil')},
                    {include:['cps.disk.used'], guid:guid(), title: this.$t('detail.text.diskUsed')},
                    {include:['cps.disk.util'], guid:guid(), title: this.$t('detail.text.diskUtil')},
                    {include:['cps.disk.bytes.read',
                            'cps.disk.bytes.write'
                    ], guid:guid(), title: this.$t('detail.text.diskReadWrite')},
                    {include: [
                        'cps.disk.counts.read',
                        'cps.disk.counts.write'
                    ], guid:guid(), title: this.$t('detail.text.diskCountReadWrite')},
                    {include:[
                        'cps.network.bytes.ingress',
                        'cps.network.bytes.egress'
                    ], guid:guid(), title: this.$t('detail.text.networkTraffic')},
                    {include:[
                        'cps.network.packets.ingress',
                        'cps.network.packets.egress'
                    ], guid:guid(), title: this.$t('detail.text.networkPacket')},
                    {include:['cps.tcp.connect.total'], guid:guid(), title: this.$t('detail.text.tcPConnectionCount')},
                    {include:['cps.tcp.connect.established'], guid:guid(), title: this.$t('detail.text.activeTCPConnections')},
                    {include:['cps.process.total'], guid:guid(), title: this.$t('detail.text.totalProcessCount')},
                    // GPU监控组件
                    // {include:['cps.gpu.memory.total'], guid:guid(),initialTitle: this.$t('detail.text.gpuMemoryTotal') + "（GB）", title: this.$t('detail.text.gpuMemoryTotal') },
                    // {include:['cps.gpu.util'], guid:guid(),initialTitle: this.$t('detail.text.gpuUtilization') + "%", title: this.$t('detail.text.gpuUtilization') },
                    // {include:['cps.gpu.memory.used'], guid:guid(),initialTitle: this.$t('detail.text.gpuMemoryUsed') + "（GB）", title: this.$t('detail.text.gpuMemoryUsed') },
                    // {include:['cps.gpu.memory.util'], guid:guid(),initialTitle: this.$t('detail.text.gpuMemoryUtilization') + "%", title: this.$t('detail.text.gpuMemoryUtilization') },
                ];
                // windows镜像，如果符合展示GPU监控的路由，则添加GPU监控
                if (this.canShowGPUMonitor) {
                    this.metrics = this.metrics.concat(gpuMonitors);
                }
            } else {
                this.metrics = [
                    {include:['cps.cpu.util'], guid:guid(), title: this.$t('detail.text.cpuUsed')},
                    {include:['cps.memory.util'], guid:guid(), title: this.$t('detail.text.memoryUsed')},
                    {include:['cps.memory.used'], guid:guid(), title: this.$t('detail.text.memoryUtil')},
                    {include:['cps.disk.used'], guid:guid(), title: this.$t('detail.text.diskUsed')},
                    {include:['cps.disk.util'], guid:guid(), title: this.$t('detail.text.diskUtil')},
                    {include:['cps.disk.bytes.read',
                            'cps.disk.bytes.write'
                    ], guid:guid(), title: this.$t('detail.text.diskReadWrite')},
                    {include: [
                        'cps.disk.counts.read',
                        'cps.disk.counts.write'
                    ], guid:guid(), title: this.$t('detail.text.diskCountReadWrite')},
                    {include:[
                        'cps.network.bytes.ingress',
                        'cps.network.bytes.egress'
                    ], guid:guid(), title: this.$t('detail.text.networkTraffic')},
                    {include:[
                        'cps.network.packets.ingress',
                        'cps.network.packets.egress'
                    ], guid:guid(), title: this.$t('detail.text.networkPacket')},
                    {include:['cps.avg.load1'], guid:guid(), title: this.$t('detail.text.oneMinuteLoadAverage')},
                    {include:['cps.avg.load5'], guid:guid(), title: this.$t('detail.text.fiveMinuteLoadAverage')},
                    {include:['cps.avg.load15'], guid:guid(), title: this.$t('detail.text.fifteenMinuteLoadAverage')},
                    {include:['cps.tcp.connect.total'], guid:guid(), title: this.$t('detail.text.tcPConnectionCount')},
                    {include:['cps.tcp.connect.established'], guid:guid(), title: this.$t('detail.text.activeTCPConnections')},
                    {include:['cps.process.total'], guid:guid(), title: this.$t('detail.text.totalProcessCount')},
                    // GPU监控组件
                    // {include:['cps.gpu.memory.total'], guid:guid(),initialTitle: this.$t('detail.text.gpuMemoryTotal') + "（GB）", title: this.$t('detail.text.gpuMemoryTotal') },
                    // {include:['cps.gpu.util'], guid:guid(),initialTitle: this.$t('detail.text.gpuUtilization') + "%", title: this.$t('detail.text.gpuUtilization') },
                    // {include:['cps.gpu.memory.used'], guid:guid(),initialTitle: this.$t('detail.text.gpuMemoryUsed') + "（GB）", title: this.$t('detail.text.gpuMemoryUsed') },
                    // {include:['cps.gpu.memory.util'], guid:guid(),initialTitle: this.$t('detail.text.gpuMemoryUtilization') + "%", title: this.$t('detail.text.gpuMemoryUtilization') },
                ];
                // 非windows镜像，如果符合展示GPU监控的路由，则添加GPU监控
                if (this.canShowGPUMonitor) {
                    this.metrics = this.metrics.concat(gpuMonitors);
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.monitor-header {
    background-color: #f3f7fb;
    border: 1px solid #d9e1e9;
}

.jc-button-icon {
    margin-right:10px;
}

.time-header {
    display: flex;
    align-items:center;
    margin: 15px;
}

.monitor-alarm-rule {
    margin-left: auto;
}

.select-instance {
    display:inline-block;
    margin-left: 40px;
    margin-bottom: 10px;
}

.select-disk {
    width: 200px;
    margin-right: 10px;
    display:inline-block;
}

.el-date-editor {
    margin-left: 10px;
}

.monitor-chart {
    background: white;
    border-bottom: 1px solid #d9e1e9;
    border-left: 1px solid #d9e1e9;
    border-right: 1px solid #d9e1e9;
}

.add-border {
    visibility: hidden;
    clear: both;
}

.el-radio-group .jc-icon-my-help {
    line-height: 18px;
    margin-top: 7px;
    margin-left: -17px;
    margin-right: 10px;
    vertical-align: middle;
}
.el-radio {
    margin: 0 0 0 20px;
}


</style>




// WEBPACK FOOTER //
// src/components/common/PerformanceMonitor/index.vue